import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductWalletMovements } from '@/features/wallet-movements'

export const Route = createFileRoute(
  '/_event/extrato-de-recompensas'
)({
  component: DigitalProductWalletMovementsPage
})

function DigitalProductWalletMovementsPage() {
  const digitalProductId = useRouteDigitalProductId()

  return <DigitalProductWalletMovements digitalProductId={digitalProductId} />
}
